export function getSegmentedTabsOuterSx(isFullWidth, maxWidth, minHeight = 34) {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: isFullWidth ? '100%' : 'max-content',
    maxWidth: maxWidth ?? 'none',
    minWidth: isFullWidth ? 0 : undefined,
    minHeight,
    overflowX: 'auto',
    flexShrink: 0,
    alignSelf: isFullWidth ? 'stretch' : 'flex-start',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
  }
}
